import { Check, Code2, KeyRound } from "lucide-react";

export const AppAccessIllustration = () => (
  <div
    aria-hidden="true"
    className="relative m-4 flex min-h-80 items-center justify-center overflow-hidden rounded-xl border bg-primary/5 p-6 sm:m-6 sm:p-10 lg:ml-0"
  >
    <div
      className="absolute inset-0 opacity-40"
      style={{
        backgroundImage:
          "linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)",
        backgroundSize: "32px 32px",
      }}
    />
    <div className="absolute -right-8 top-12 size-48 rounded-full bg-chart-1/10" />
    <div className="absolute -left-10 bottom-0 size-40 rounded-full bg-primary/10" />
    <div className="relative w-full max-w-sm -rotate-2 rounded-xl border bg-card p-5 shadow-sm sm:p-6">
      <div className="flex items-center gap-3">
        <div className="grid size-11 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary">
          <Code2 className="size-6" />
        </div>
        <div>
          <p className="font-semibold">Your next app</p>
          <p className="text-xs text-muted-foreground">
            Powered by Geoscape Verify
          </p>
        </div>
      </div>
      <div className="mt-5 space-y-3 border-t pt-5">
        {[
          "Autocomplete & Address Verify",
          "MailPoint Verify",
          "Phone & Email Verify",
        ].map((service) => (
          <div key={service} className="flex items-center gap-2 text-sm">
            <Check className="size-4 shrink-0 text-primary" />
            {service}
          </div>
        ))}
      </div>
      <div className="mt-5 flex items-center gap-2 rounded-lg bg-muted/50 px-3 py-2.5 text-xs text-muted-foreground">
        <KeyRound className="size-4 shrink-0 text-primary" />
        API access for your integration
      </div>
    </div>
  </div>
);
